//
//
//
//
//
//
//
//

import { createNamespacedHelpers } from 'vuex'
import Genesys from '@/scripts/libs/genesys'

import wcs from '@/scripts/libs/wcs'
const { mapGetters: mapGettersGenesys } = createNamespacedHelpers('genesys')
const { pagesWithoutChat, viewTaskName } = wcs.getStoreConfig()

export default {
  name: 'rb-genesys',
  computed: {
    ...mapGettersGenesys(['buttonIsVisible', 'areScriptsLoaded']),
    canShowGenesys() {
      return !pagesWithoutChat?.includes(viewTaskName)
    },
  },
  methods: {
    openChat() {
      Genesys.openGenesysChat()
    },
  },
}
